<script>
// import Swal from 'sweetalert2'
import cleanCacheVersion from './helpers/clean-cache-version';

export default {
  beforeMount() {
    cleanCacheVersion();
    /*
    Swal.fire({
      hideOnOverlayClick: false,
      hideOnContentClick: false,
      closeClick: false,
      helpers: {
        overlay: { closeClick: false }
      },
      closeOnClickOutside: false,
      showConfirmButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      title: 'OnlyPay Informa',
      html: `<p style="text-align: left;">Em virtude do feriado de Corpus Christi, não haverá expediente no dia 16.06, retornaremos as atividades em 17.06 às 9hrs.
      <br>Desta forma, os serviços de pagamentos de boletos e contas, transferências bancárias serão compensadas no próximo dia útil.
      <br>Para maiores informações acesse sua conta no site onlypay.com.br.</p>`,
      type: 'info'
    })
    */
    // Swal.fire({
    //   html: `
    //     <div style='text-align: left;color: #6c757d!important; font-size: medium;'>
    //       <h3 style='font-size: 1.75rem;'>Prezado Cliente</h3>
    //       <br />
    //       <p style="text-align: justify;">
    //         Nosso site esta passando por atualização na data de hoje
    //         Retornaremos na terça feira dia 28/02/2023.<br>
    //         Agradecemos sua compreensão.
    //       </p>
    //         <br />
    //         <br />
    //         <br />
    //         <center>Equipe OnlyPay</center>
    //     </div>
    //   `,
    //   type: 'warning',
    //   showConfirmButton: false,
    //   confirmButtonText: 'Voltar',
    //   allowOutsideClick: false,
    //   allowEscapeKey: false,
    //   allowEnterKey: false
    // })
  }
}
</script>

<template>
  <div id="app">
    <router-view />
    <transition name="message">
      <div
        v-if="$store.state.message.text"
        v-bind:class="`message message--${$store.state.message.type}`"
        v-html="$store.state.message.text"/>
    </transition>
    <div v-if="$store.state.pageLoading" class="page-loading">
      <div class="page-loading__content">
        <svg class="page-loading__content__img" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            fill="#002323"
            d="M13.0834 0.338829C3.38636 0.257409 -2.26673 8.99358 0.456373 19.8536C2.47748 27.9159 8.54965 34.8781 15.5112 37.9634L13.4866 15.0516C13.2479 12.3838 13.8915 10.2565 15.4759 9.3591C18.5031 7.64755 23.7849 11.0585 27.2736 16.9779C30.7624 22.8973 31.1373 29.0852 28.11 30.7968C26.0235 31.9765 22.8654 30.7223 19.9602 27.8882L21.0017 39.5277C21.6488 39.6092 22.296 39.6559 22.9414 39.6611C32.6385 39.7425 38.2916 31.0064 35.5685 20.1464C32.8454 9.28808 22.777 0.418517 13.0817 0.337097L13.0834 0.338829Z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<style lang="postcss">
@import 'bootstrap/dist/css/bootstrap-grid.min.css';
@import './assets/css/font.css';
@import './assets/css/main.css';

select[disabled], input[disabled]{
  opacity: 0.6;
  cursor: default;
}
#app {
  height: 100%;
  .message {
    color: var(--color-white);
    padding: 1rem;
    position: fixed 0 0 auto 0;
    text-align: center;
    z-index: 1000;
    &--info {
      background-color: var(--color-green);
    }
    &--error {
      background-color: var(--color-red);
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(-1rem);
    }
    &-enter-to, &-leave {
      opacity: 1;
      transform: translateY(0%);
    }
    &-enter-active, &-leave-active {
      transition: all 750ms;
    }
  }
  .page-loading {
    align-items: center;
    background-color: var(--color-white);
    display: flex;
    justify-content: center;
    position: fixed 0 0 58px 0;
    z-index: 1000;
    @media (min-width: 992px) {
      bottom: 0;
      top: 110px;
    }
    &__content {
      align-items: center;
      display: flex;
      justify-content: center;
      size: 3.5rem;
      &__img {
        animation: page-loading-pulse 1.4s ease-in-out infinite;
        display: block;
        size: 3rem;
      }
    }
  }
}

@keyframes page-loading-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
.fade {
  &-enter-active {
    transition: all 250ms ease-in;
  }
  &-leave-active {
    transition: all 250ms ease-out;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
/* SweetAlert2 aplica height:auto no body e quebra layouts com height:100% (ex.: login + 2FA) */
body.swal2-height-auto {
  height: 100% !important;
}

/* Acima do modal de 2FA (z-index 2000); abaixo do overlay de loading (9999) */
.swal2-container {
  z-index: 3000 !important;
}

.swal2-title {
  font-size: 1.6rem!important;
}
.swal2-content {
  font-size: 18px!important;
}
.swal2-radio {
  label {
    font-size: 18px!important;
  }
  font-size: 18px!important;
}
.swal2-radio input,
.swal2-checkbox input {
  accent-color: var(--color-primary) !important;
  cursor: pointer;
}

/* Botão do SweetAlert2 – rebranding (cor e fonte) */
.swal2-confirm {
  background-color: var(--color-primary) !important;
  font-family: 'Plus Jakarta Sans', sans-serif !important;
}
.swal2-confirm:hover,
.swal2-confirm:focus {
  background-color: var(--color-blue-light) !important;
}
</style>
